export interface PerformanceThreshold {
  level: string;
  minPercentage: number;
  color: string;
  description?: string;
}

export const getDefaultThresholds = (): PerformanceThreshold[] => [
  { level: 'Überzeugend', minPercentage: 90, color: 'success', description: 'Hervorragende Leistung in allen Bereichen' },
  { level: 'Sehr gut', minPercentage: 75, color: 'chart-3', description: 'Überdurchschnittliche Leistung' },
  { level: 'Gut', minPercentage: 60, color: 'primary', description: 'Solide und zuverlässige Leistung' },
  { level: 'Teilweise gut', minPercentage: 40, color: 'warning', description: 'Akzeptable Leistung mit Verbesserungspotenzial' },
  { level: 'Verbesserungsbedarf', minPercentage: 0, color: 'destructive', description: 'Deutliche Verbesserung erforderlich' },
];

export const getPerformanceLevelFromThresholds = (
  score: number,
  maxScore: number,
  thresholds: PerformanceThreshold[]
): string => {
  if (maxScore === 0) return "Nicht bewertet";
  
  const percentage = (score / maxScore) * 100;
  // Sort thresholds from HIGHEST to LOWEST percentage
  const sortedThresholds = [...thresholds].sort((a, b) => b.minPercentage - a.minPercentage);
  
  // Find the first threshold where percentage is >= the threshold value
  for (const threshold of sortedThresholds) {
    if (percentage >= threshold.minPercentage) {
      return threshold.level;
    }
  }
  
  // If percentage is lower than all thresholds, return the lowest level
  return sortedThresholds[sortedThresholds.length - 1]?.level || "Nicht bewertet";
};
